<template>
  <div>
    <div class="position-relative">
      <div class="container pt-5" style="margin-top:100px">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-12  mb-5">
            <h1 class=" display-3 ">Global Solutions</h1>
            <p class="lead  text-left ">
              As a global business, you already know that successful project
              deployments depend just as much on smart decisions to buy the
              right equipment, as ensuring that equipment gets to the right
              place at the right time. And business success is dependent on how
              the approach to deployment strategy.
            </p>

            <p class="lead text-left">
              Whether you are a global company with an established presence
              around the world, or a multi- national organization looking to
              expand into more emerging markets, you need an IT partner that
              knows the global business and understands models of global
              procurement. You need a partner that not only understands IT but
              also understands the unique laws, taxes and customs procedures of
              shipping that IT equipment into countries all over the world. And,
              you need a partner who can do all of this while providing you with
              visibility, control and advice through each step of the process.
            </p>
          </div>
        </div>
      </div>
    </div>

    <section class="section container section-lg mt--100">
      <div class="row justify-content-between align-items-center">
        <div class="col-md-7">
          <h5>
            WHAT IS THE DIFFERENCE BETWEEN UNIVERSAL TECH AND A FORWARDER/CARRIER?
          </h5>
          <p class="lead">
            The difference is significant. A carrier or forwarder simply handles
            the physical movement of the goods from origin to destination – they
            will not act as local consignee/IOR and will therefore assume no
            compliance risk. If the goods get stuck in customs, they are sent
            back to you. Universal Tech works with all carriers/forwarders (yours or our
            own) to provide a complete service – that is a door-to-door
            solution.
          </p>
        </div>
        <div class="col-md-5 p-1">
          <img  class="img-fluid " src="img/theme/global4.png"/>
        </div>
      </div>
    </section>
    <section class="section section-lg mt--100">
      <div class="container ">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <a href="tel:1-888-886-4775" target="_blank">
              <img src="img/theme/4.png" class="img-fluid floating"
            /></a>
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="fa fa-heart"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3>Our promise</h3>
              <p>
                We’ll bring the following strengths to our work for you as we
                believe that strength comes with simple principles:
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="fa fa-users"></i
                    ></span>
                    <h6 class="mb-0">
                      True collaboration with customers and partners
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="fa fa-underline"></i
                    ></span>
                    <h6 class="mb-0">
                      Complete understanding of customers business
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="ni ni-settings"></i
                    ></span>
                    <h6 class="mb-0">
                      Continuing to finish the job professionally
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="fa fa-thumbs-up"></i
                    ></span>
                    <h6 class="mb-0">Top quality assurance</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img v-lazy="'img/theme/ban3.png'" class="card-img-top" />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Why Universal Tech?
                </h4>
                <p class="lead text-italic text-white">
                  Our expertise, resources, and attention to detail make us
                  stand out and the ideal choice to meet the client’s needs for
                  an infrastructure and security solution.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon
                name="ni ni-satisfied"
                class="mb-5"
                size="lg"
                type="warning"
                shadow
                rounded
              ></icon>

              <h3>Our customers</h3>
              <p class="lead">
                The customers want to excel in every aspect of its business,
                which means it will need to take advantage of the best
                technological tools available in order to gain an edge over its
                competitors. This is the reason you want a company like
                Universal Tech LLC to provide you with a customized solution to
                maximize efficiency and security, minimize cost, and achieve
                your unique goals.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Reliable Service</h2>
            <p class="lead text-white">
              With our 24/7 support, our team can resolve problems in a fast and
              efficient way to keep your business up and to run smoothly. We all
              want to be part of a team that leaves a legacy and remembered for
              years about what we have achieved.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <EmailForm></EmailForm>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              <span class="text-success"
                >Innovation is our Passion</span
              >
            </h2>
            <p class="lead">
              We approach new technology and continue to innovate. As a result,
              Universal Tech LLC has established and will continue to establish
              a long history for developing and providing high-quality IT
              Solutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import EmailForm from "./components/EmailForm";

export default {
  components: {
    BCarousel,
    BCarouselSlide,
    EmailForm,
  },
};
</script>
<style scoped>
.shape-container {
  padding-bottom: 5rem;
}
</style>
